import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "287",
  "slug": "spot-italy-from-satellite-imagery",
  "title": "How to Recognise Italy in Satellite Images",
  "excerpt": "Northern Italy contains the broad Po plain below the Alps.",
  "date": "2026-05-09",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/italy.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Northern Italy contains the broad Po plain below the Alps. The Apennines continue down the peninsula, leaving coastal lowlands of varying width. Sicily sits near the toe of the mainland, and Sardinia lies farther west. These large relationships are useful even when individual towns are unfamiliar."
    },
    {
      "type": "heading",
      "text": "The Po plain and the Apennines"
    },
    {
      "type": "paragraph",
      "text": "Trace the Po east towards the Adriatic, then compare that broad plain with a valley in the Apennines."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Mediterranean farmland and hilltop settlements occur in Spain, Greece, and other countries. A small crop needs more context than red roofs. Identify whether the terrain fits a plain below the Alps or the narrower peninsula."
    }
  ],
  "imageAlt": "Italy regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
